module.exports = __webpack_public_path__ + "img/spinner_sm.e5c6a97b.gif";